exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header[data-v-1cbaf876]{width:100%;height:64px;background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.header img[data-v-1cbaf876]{height:50px;margin-left:25px}.header span[data-v-1cbaf876]{line-height:64px;margin-left:18px;font-weight:700;font-size:18px;letter-spacing:2px}.header span[data-v-1cbaf876]:before{content:\"|\";position:relative;right:8px;top:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1cbaf876&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pc/header.vue
// module id = 156
// module chunks = 0